import { Building2 } from "lucide-react";

const manifest = {
  key: "companies_management",
  isFreeModule: false,
  isPurchasable: true,
  icon: Building2,
  names: {
    plan: {
      en: "Companies Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u0634\u0631\u0643\u0627\u062a",
    },
    dashboard: {
      en: "All Companies",
      ar: "\u062c\u0645\u064a\u0639 \u0627\u0644\u0634\u0631\u0643\u0627\u062a",
    },
  },
  defaultPath: "/premium-subscribers",
  matchers: [/^\/company-list(?:\/|$)/, /^\/premium-subscribers(?:\/|$)/],
  buildNavbarMenus: ({ t, activeModuleLabel, COMPANY_LIST_ENABLED }) => [
    {
      label: activeModuleLabel,
      path: "__companies__",
      children: [
        {
          label: t("menu_all_companies") || "All Companies",
          path: "/company-list",
          disabled: !COMPANY_LIST_ENABLED,
          disabledReason: !COMPANY_LIST_ENABLED ? "soon" : undefined,
        },
        {
          label: t("premium_subscribers_menu") || "Premium Subscribers",
          path: "/premium-subscribers",
        },
      ],
    },
  ],
};

export default manifest;
